import { Form, TreeSelect, Select, Typography, Flex } from 'antd'
import React from 'react'

import { GroupType } from '@/model/group'
import { selectGroupTreeData } from '@/redux/group-selectors'
import { selectRoleOptions } from '@/redux/role-selectors'
import { useAppSelector } from '@/redux/utils'

import useSelectedEmployees from '../hooks/use-selected-employees'

import s from './batch-operations-fields.module.css'

const { Text, Title } = Typography

const { Item } = Form

interface BatchEditFieldsProps {
  selectedEmployeeIds: number[];
}

export function BatchEditGroupFields(props: BatchEditFieldsProps) {
  const groupOptions = useAppSelector((state) =>
    selectGroupTreeData(state, GroupType.Employee),
  )

  const { employeeNames } = useSelectedEmployees(props.selectedEmployeeIds)

  return (
    <Flex vertical gap={8}>
      <Flex vertical>
        <Title ellipsis={true} level={5} className={s.selectedEmployeeNames}>
          Selected employees: {employeeNames}
        </Title>
        <Text type="secondary">
          Choose the group you wish to assign them to
        </Text>
      </Flex>
      <Item name="groupId" label="Group" required rules={[{ required: true }]}>
        <TreeSelect<number>
          treeData={groupOptions}
          treeDefaultExpandAll
          allowClear
          placeholder="Select group"
        />
      </Item>
    </Flex>
  )
}

export function BatchEditRolesFields(props: BatchEditFieldsProps) {
  const rolesOptions = useAppSelector(selectRoleOptions)
  const { employeeNames } = useSelectedEmployees(props.selectedEmployeeIds)

  return (
    <Flex vertical gap={8}>
      <Flex vertical>
        <Title ellipsis={true} level={5} className={s.selectedEmployeeNames}>
          Selected employees: {employeeNames}
        </Title>
        <Text type="secondary">
          Choose the role(s) you wish to assign them t:
        </Text>
      </Flex>
      <Item name="roleIds" label="Role" required rules={[{ required: true }]}>
        <Select
          mode="multiple"
          placeholder="Select role"
          options={rolesOptions}
          allowClear
        />
      </Item>
    </Flex>
  )
}

export function BatchDeleteFields(props: BatchEditFieldsProps) {
  const { employeeNames } = useSelectedEmployees(props.selectedEmployeeIds)
  return (
    <Flex vertical gap={8}>
      <Flex vertical>
        <Title ellipsis={true} level={5} className={s.selectedEmployeeNames}>
          Selected employees: {employeeNames}
        </Title>
        <Text type="secondary">
          Are you sure you want to delete these employees?
        </Text>
      </Flex>
    </Flex>
  )
}
